import { useTranslation } from 'react-i18next'

import { DeliverableStage } from '@maxus/common'
import { StageChip, VideoThumb } from '@maxus/website/components'

type PanelVideoSummaryProps = {
  projectName: string
  deliverableName: string
  stageName: string
  versionNumber: number
  platformName: string
  coverUrl: string | null
  commentsCount: number
}

export const PanelVideoSummary = ({
  projectName,
  deliverableName,
  stageName,
  versionNumber,
  platformName,
  coverUrl,
  commentsCount,
}: PanelVideoSummaryProps) => {
  const { t } = useTranslation()
  const titleParts = [
    projectName,
    deliverableName,
    `V${versionNumber}`,
    platformName === 'default' ? null : platformName,
  ].filter(Boolean)

  return (
    <div
      className="flex min-h-[70px] items-center gap-3 rounded-lg bg-surface-card px-3 py-2"
      data-slot="mmam-panel-video-summary"
    >
      <VideoThumb className="h-[50px] w-[50px]" src={coverUrl} />
      <div className="min-w-0 flex-1">
        <div className="truncate text-sm font-semibold text-text-primary">{titleParts.join(' / ')}</div>
        <div className="mt-1 text-xs text-text-tertiary">
          {t('Contains {{count}} comments', { count: commentsCount })}
        </div>
      </div>
      <StageChip stage={stageName as DeliverableStage} />
    </div>
  )
}
